/* globals google */
import $ from 'jquery';

export const reset = ($form) => {
    var $address = $form.find('[data-address-prefill]');

    $address.removeAttr('data-address');
    $address.removeData('address');
};
export const populateInputs = (data, $parent) => {
    var $input,
        $form = $parent.closest('.form'),
        tmpKey,
        mapping = [
            'unit_number', 'address', 'suburb', 'postcode', 'state', 'country'
        ];

    for(var i=0; i<mapping.length; i++) {
        tmpKey = mapping[i];
        $input = $parent.find('[data-prefill-type="' + tmpKey + '"]');

        if($input.length) {
            if(typeof(data[tmpKey]) !== 'undefined') {
                $input.val(data[tmpKey]);
            }
            else {
                $input.val('');
            }

            $input.trigger('keyup.field');
            $form.trigger('update', $input);
        }
    }
};
export const create = ($el) => {
    var $address = ($el) ? $el.find('[data-address-prefill]') : $('[data-address-prefill]');

    $address.each(function (i) {
        var autocomplete,
            $input = $(this),
            $block = $input.closest('[data-block]'),
            $prefillGroup = $block.next(),
            $form = $input.closest('.form'),
            options = $.extend(true, {
                types: ['address'],
                componentRestrictions: {
                    country: 'au'
                }
            }, $input.data('autocomplete-options'));

        // Create the autocomplete object, restricting the search to geographical location types.
        autocomplete = new google.maps.places.Autocomplete($address[i], options);

        $input.on('keydown', function (event) {
            if (event.which == 13) {
                if ($('.pac-container:visible').length) {
                    event.preventDefault();
                    return false;
                }
            } else {
                $(this).removeAttr('data-address');
                $(this).removeData('address');
            }
        });

        // on change
        google.maps.event.addListener(autocomplete, 'place_changed', function () {
            var place = autocomplete.getPlace(),
                openDetailedForm = false,
                fetched_address = {},
                combined_address = '',
                // street_name = '',
                // street_suffix = '',
                // unit_number = '',
                street_number = '',
                street_number_1 = '',
                street_number_2 = '',
                newData = {},
                inputName = $input.data('google-address') ? $input.data('google-address') + '_' : '',
                enteredValue = $input.val(),
                lowercase_street_name = '',
                street_array = '',
                street_last_word = '',
                componentForm = {
                    subpremise: 'short_name',
                    street_number: 'short_name',
                    route: 'long_name',
                    locality: 'long_name',
                    administrative_area_level_1: 'short_name',
                    country: 'short_name',
                    postal_code: 'short_name'
                },
                tmpUnitNumber;

            if (typeof(place.address_components) !== 'undefined') {

                // Get each component of the address from the place details
                // and fill the corresponding field on the form.

                for (var i = 0; i < place.address_components.length; i++) {
                    var addressType = place.address_components[i].types[0];
                    if (componentForm[addressType]) {
                        var val = place.address_components[i][componentForm[addressType]];
                        fetched_address[addressType] = val;
                    }
                }

                // Split Street Number to Unit Number & Street Number
                if (typeof(fetched_address.street_number) !== 'undefined' ) {
                    street_number = fetched_address.street_number;

                    // append FULL ADDRESS
                    combined_address = fetched_address.street_number;
                }

                // Check Street Number if it has '-'
                if (street_number !== '') {
                    if(street_number.indexOf('-') > -1) {
                        var street_number_res = street_number.split('-');
                        street_number_1 = street_number_res[0];
                        street_number_2 = street_number_res[1];
                    }
                    else {
                        street_number_1 = street_number;
                    }
                }
                else {
                    openDetailedForm = true;
                }

                // Check for suffix in street_name
                if (typeof(fetched_address.route) !== 'undefined') {
                    lowercase_street_name = fetched_address.route.toLowerCase();
                    street_array = lowercase_street_name.split(' ');
                    street_last_word = street_array[street_array.length - 1];

                    // append FULL ADDRESS
                    if (combined_address.length) {
                        combined_address += ' ';
                    }
                    combined_address += fetched_address.route;
                }

                // new data
                newData[inputName + 'address'] = combined_address;
                newData[inputName + 'street_type'] = street_last_word;
                newData[inputName + 'unit_number'] = fetched_address.subpremise;
                newData[inputName + 'street_number'] = street_number_1;
                newData[inputName + 'street_number_2'] = street_number_2;
                newData[inputName + 'street_name'] = fetched_address.route;
                newData[inputName + 'suburb'] = fetched_address.locality;
                newData[inputName + 'postcode'] = fetched_address.postal_code;
                newData[inputName + 'state'] = fetched_address.administrative_area_level_1;
                newData[inputName + 'country'] = fetched_address.country;

                // lazy backend code
                if (inputName == 'check') {
                    delete newData.check_street_type;
                    newData.street_type = street_last_word;
                }

                // Force add unit
                if(enteredValue.indexOf('/') != -1) {
                    tmpUnitNumber = enteredValue.split('/');
                }
                else if(enteredValue.indexOf('-') != -1) {
                    tmpUnitNumber = enteredValue.split('-');
                }

                if(tmpUnitNumber && !newData[inputName + 'unit_number']) {
                    newData[inputName + 'unit_number'] = tmpUnitNumber[0].trim();
                }

                // Check if has unit
                if(newData['unit_number']) {
                    openDetailedForm = true;
                }

                if(openDetailedForm) {
                    populateInputs(newData, $prefillGroup);
                    showFullAddress($input);
                }

                // append data
                // $input.data('address', $.param(newData));
                $input.attr('data-address', true);
                $input.data('address', newData);

                // force validation
                $input.trigger('keyup.field');

                // keep data
                $form.trigger('update', $input);
            }
            else {
                // append data
                // $input.data('address', place.name);
                console.log('no address data');
            }
        });
    });
};
export const showFullAddress = ($el) => {
    var $block = $el.closest('[data-block]'),
        $nextBlock = $block.next();
    $nextBlock.removeClass('hidden');
    $block.addClass('hidden');
};
export const binds = ($el) => {
    create();
    // ---------------- show full address form
    $('#wrapper').on('click.address', '[data-show-prefill-fullform]', function (event) {
        event.preventDefault();
        showFullAddress($(this));
    });
};
